import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-conversion-bar',
  templateUrl: './conversion-bar.component.html',
  styleUrls: ['./conversion-bar.component.scss'],
})
export class ConversionBarComponent {
  @Input() oldLamp: any;
  @Input() newLamp: any;
  @Input() count: number = 0;
}
